import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import ServiceCatalogForm from './components/ServiceCatalog/ServiceCatalogForm';
import CheckoutForm from './components/Checkout/CheckoutForm';
import AdminPage from './components/Checkout/AdminPage';
import PaymentResponse from './components/Checkout/PaymentResponse';
import UserDefinedRegion from './components/PurchaseProduct/UserDefinedRegion';

import PageNotFound from './components/Error/PageNotFound';
import ExpiredSubscription from './components/Error/ExpiredSubscription';
import UnavailableProduct from './components/Error/UnavailableProduct';

import STPDataMap from './components/PurchaseProduct/STPDataMap';
import DownloadableGISData from './components/PurchaseProduct/DownloadableGISData';
import 'bootstrap/dist/css/bootstrap.min.css';
import "mdbreact/dist/css/mdb.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";

import logo from './images/logo-iwk.png';
import facebook from './images/facebook.png';
import twitter from './images/tw.png';
import instagram from './images/instagram.png';
import Header from './components/Home/Header';

class App extends Component {
    constructor(props) {
        super(props);
        this.goToHome = this.goToHome.bind(this);
    }

    goToHome() {
        window.open("/indahgeoportal", "_blank");
    }

    render() {
        return (
            <div className="App">
                <header className="App-header">
                </header>
                <div className="App-body">
                    <Router basename="/indahgeoportal/">
                        <div className="wrapper-full">
                            <div className="background-image" onClick={this.goToHome} style={{ cursor: "pointer" }}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-sm-12 pt-2">
                                            <img src={logo} alt="indah water logo" width="210" className="float-left img-fluid" />
                                            <div className="indah-water-header"> Indah Geoportal </div>
                                        </div>
                                    </div>
                                    {/*<div className="row">
                                        <div className="col-sm-3 mt-3">
                                            <img src={logo} alt="indah water logo" className="float-left img-fluid" />
                                        </div>
                                        <div className="col-sm-9">
                                            <div className="indah-water-header"> Indah GeoPortal </div>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            <Header />

                            <Switch>
                                <Route exact path="/" component={ServiceCatalogForm} />
                                <Route path="/Checkout" component={CheckoutForm} />
                                <Route path="/PaymentResponse/:id" component={PaymentResponse} />
                                <Route exact path="/UserDefinedRegion/:id" component={UserDefinedRegion} />
                                <Route exact path="/map" component={Map} />
                                <Route exact path="/STPData/:id" component={STPDataMap} />
                                <Route exact path="/DownloadableGisData/:id" component={DownloadableGISData} />
                                <Route exact path="/ExpiredSubscription" component={ExpiredSubscription} />
                                <Route exact path="/UnavailableProduct" component={UnavailableProduct} />
                                <Route exact path="/admin" component={AdminPage} />
                                <Route path='*' component={PageNotFound} />
                            </Switch>

                            <footer className="footer-distributed clearfloat">
                                <div className="wrapper">
                                    <div className="footer-left">
                                        <a href="https://www.facebook.com/IndahWaterKonsortium" target="_blank"><img alt="Indah Water Konsortium Sdn Bhd (211763-P) facebook" src={facebook} /></a>
                                        <a href="https://twitter.com/iwkcomms" target="_blank"><img alt="Indah Water Konsortium Sdn Bhd (211763-P) twiter" src={twitter} /></a>
                                        <a href="https://www.instagram.com/iwk_official" target="_blank"><img alt="Indah Water Konsortium Sdn Bhd (211763-P) instagram" src={instagram} height="25" /></a>
                                    </div>
                                    <div className="footer-left-text">
                                        <p className="footer-links">
                                            <i className="fa fa-copyright fa-sm" aria-hidden="true"></i> Indah Water Konsortium Sdn Bhd (211763-P). All Rights Reserved.<a href="https://www.iwk.com.my/" target="_blank"> Indah Water </a></p>
                                        <p className="footer-links">No.1, Jalan Damansara, 60000, Kuala Lumpur, Malaysia. Tel: +603-2780 1100, <a href="mailto:care@iwk.com.my">igeoportal@iwk.com.my</a></p>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </Router>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js